import { useContext } from 'react';
import { Alert, ListGroup } from 'react-bootstrap';
import InterfaceContext from '../Context';
import { useLocalizedStrings } from '../Localization';
import { languageContent, safeParse, getBadgeVariant } from '../Util';
import { QuestionProps } from './Props';

type VerificationCheck = {
  name: string,
  status: string,
  reasons: string[],
  metadata: any
};

function IdentityFlagReview(props: QuestionProps){
  const context = useContext(InterfaceContext);
  
  const L = useLocalizedStrings();
  
  const targetField = props['Target Field']!;
  
  const checks =
        (safeParse(props.info[targetField] || "{}") as any)[
          "checks"
        ] || [];
  
  const comment = props.info[targetField + "_comment"] || "";
  
  if (checks.length) {
    return (
      <Alert variant="danger">
        {props[languageContent(context.lang)]}
        <br />
        <br />
        <ol>
          {checks &&
                checks.map((check: VerificationCheck, i: number) => {
                  if (check.status === 'not_applicable') return <></>;
                  return (
                    <li>
                      {check.name}&nbsp;{getBadgeVariant(check.status, L.questions.identity.passed, L.questions.identity.failed)}
                      <ListGroup>
                        {check.reasons && check.reasons.map((reason: string) => {
                          return (
                            <ListGroup.Item variant="danger">
                              {reason}
                            </ListGroup.Item>
                          )
                        })}
                      </ListGroup>
                    </li>
                  );
                })}
        </ol>
        <br />
        {comment && <>{L.questions.flags.the_screener_said} {comment}</>}
      </Alert>
    );
  }
  return <></>;
}


export { IdentityFlagReview }
